/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Cc_Position_Bottom_LeftInputs */

const en_shortcut_keys_desc_cc_position_bottom_left = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Bottom_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position Events to the bottom left of the video`)
};

const fr_shortcut_keys_desc_cc_position_bottom_left = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Bottom_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positionner les evenements en bas a gauche de la video`)
};

const de_shortcut_keys_desc_cc_position_bottom_left = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Bottom_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positionieren Sie die Ereignisse unten links im Video.`)
};

const it_shortcut_keys_desc_cc_position_bottom_left = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Bottom_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posiziona gli eventi in basso a sinistra del video`)
};

const ru_shortcut_keys_desc_cc_position_bottom_left = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Bottom_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разместите события в левом нижнем углу видео.`)
};

const es_shortcut_keys_desc_cc_position_bottom_left = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Bottom_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colocar eventos en la parte inferior izquierda del vídeo`)
};

const zh_cn2_shortcut_keys_desc_cc_position_bottom_left = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Bottom_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频左下角的位置事件`)
};

const ja_shortcut_keys_desc_cc_position_bottom_left = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Bottom_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントをビデオの左下に配置する`)
};

const hi_shortcut_keys_desc_cc_position_bottom_left = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Bottom_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो के निचले बाएँ कोने में घटनाओं की स्थिति निर्धारित करें।`)
};

const pt_pt2_shortcut_keys_desc_cc_position_bottom_left = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Bottom_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posicione os eventos na parte inferior esquerda do vídeo.`)
};

/**
* | output |
* | --- |
* | "Position Events to the bottom left of the video" |
*
* @param {Shortcut_Keys_Desc_Cc_Position_Bottom_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_cc_position_bottom_left = /** @type {((inputs?: Shortcut_Keys_Desc_Cc_Position_Bottom_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Cc_Position_Bottom_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_cc_position_bottom_left(inputs)
	if (locale === "de") return de_shortcut_keys_desc_cc_position_bottom_left(inputs)
	if (locale === "it") return it_shortcut_keys_desc_cc_position_bottom_left(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_cc_position_bottom_left(inputs)
	if (locale === "es") return es_shortcut_keys_desc_cc_position_bottom_left(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_cc_position_bottom_left(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_cc_position_bottom_left(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_cc_position_bottom_left(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_cc_position_bottom_left(inputs)
	return en_shortcut_keys_desc_cc_position_bottom_left(inputs)
});